<template>
    <div>
        <fieldset
            style="max-width: 800px"
            :disabled="!runAudits">
            <div
                v-for="item in items"
                :key="item.id"
                class="d-flex mb-1 align-items-center">
                <div
                    class="form-check"
                    style="width: 260px">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        :value="item.id"
                        v-model="item.isSelected"
                        :id="`notice_${item.id}`" />
                    <label
                        class="form-check-label"
                        :for="`notice_${item.id}`">
                        {{ item.action }}
                    </label>
                </div>
                <select
                    id="agencyContactRole"
                    v-if="item.isSelected"
                    v-model="item.roleId"
                    class="form-select">
                    <option value="0">N/A - Send no emails</option>
                    <option
                        v-for="item in contacts"
                        :value="item.value"
                        :key="item.value">
                        {{ item.label }}
                    </option>
                </select>
            </div>
        </fieldset>
    </div>
</template>
<script lang="ts" setup>
import {useAuditNoticeStore} from "@/stores/auditNoticeStore";
import {useAgencyContactsStore} from "@/stores/agencyContactsStore";

import {computed, ref, watch} from "vue";
import {Audit, AuditNotice, AuditNoticeOption} from "@/audit.types";
import {clone} from "@/utils";

const model = defineModel<AuditNotice[]>();

const props = defineProps<{
    id: number;
    audit: Audit;
    runAudits: boolean;
    createAudits: boolean;
}>();

const emit = defineEmits(["update:modelValue"]);

const auditNoticeStore = useAuditNoticeStore();
const agencyContactsStore = useAgencyContactsStore();

await auditNoticeStore.list(props.id);
const items = ref<AuditNoticeOption[]>([]);
items.value = clone(auditNoticeStore.items);

await agencyContactsStore.list(props.audit.ori);

const contacts = computed(() => agencyContactsStore.items);

watch(
    () => items,
    (newValue, oldValue) => {
        var value = items
            .value!.filter((opt) => opt.isSelected)
            .map(function (opt) {
                return {noticeId: opt.id, roleId: opt.roleId};
            });
        emit("update:modelValue", value);
    },
    {deep: true}
);
</script>
